import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DirectivesUpgradedModule } from '../../../../shared/directives/directivesUpgraded.module'
import { OrderByPipeModule } from '../../../../shared/pipes/order-by-pipe.module'
import { DisplayNamePipeModule } from '../../../subject/pipes/display-name.module'
import { DisplayNumberModule } from '../../../../shared/pipes/display-number.module'
import { AttachmentTypeScanDataComponent } from './attachment-type-scan-data.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DirectivesUpgradedModule,
        OrderByPipeModule,
        DisplayNamePipeModule,
        DisplayNumberModule,
    ],
    declarations: [AttachmentTypeScanDataComponent],
    exports: [AttachmentTypeScanDataComponent],
})
export class AttachmentTypeScanDataModule {}
